<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("branches")}}</h4>
                <p class="text-subtitle-1">{{$t("branch_list")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(permissions.sales_branch.create)">
                <v-btn block color="primary" @click="onAddBranch">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("add_branch")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :page.sync="page"
                    :options.sync="options"
                    :server-items-length="serverItemsLength"
                    :headers="headers"
                    :items="data"
                    disable-sort
                    :loading="loading"
                    >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="onOpen(item)" v-if="hasPermission(permissions.sales_branch.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import authorize from '../../utils/authorize';
import branch from './../../services/sales/branch';
import permissions from '../../data/permissions';

export default {
    data() {
        return {
            page: 1,
            options: {},
            serverItemsLength: 0,
            data: [],
            loading: false,
            permissions
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("dimension"), value: "dimension" },
            ]
        }
    },
    watch: {
        options:{
            deep: true,
            handler() {
                this.fetchBranches();
            }
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchBranches() {
            this.loading = true;
            branch.index({...this.options}).then(res => {
                this.data = res.data.data;
                this.serverItemsLength = res.data.count
            }).finally(() => {
                this.loading = false;
            })
        },
        onAddBranch() {
            this.$router.push({
                name: "BranchCreate"
            })
        },
        onOpen(item) {
            this.$router.push({
                name: "BranchDisplay",
                params: {
                    id: item.id
                }
            })
        }
    }
}
</script>

<style>

</style>